import { render, staticRenderFns } from "./PurchaseHistoryModal.vue?vue&type=template&id=8acc5b8c"
import script from "./PurchaseHistoryModal.ts?vue&type=script&lang=ts&external"
export * from "./PurchaseHistoryModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports